import { useUnit } from 'effector-react';
import { Tree } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { $isDarkTheme, $language } from '../../models/authModel/index.js';
import {
  $absoluteLayers,
  changeAbsoluteLayersEv,
} from '../../models/absoluteModel/index.js';

const mock_data = [
  {
    title: 'Население',
    key: 'people_in_zid',
    selectable: false,
    type: 'hexagons',
  },
  {
    title: 'Социальная и коммерческая инфраструктура',
    key: 'soc_com_structure',
    checkable: false,
    children: [
      // {
      //   title: 'Разнообразие функций',
      //   key: 'function_variety',
      // },
      {
        title: 'Обеспеченность продуктовыми магазинами',
        key: 'idx_103_amount',
        type: 'hexagons',
      },
      {
        title: 'Обеспеченность детскими садами',
        key: 'kg',
        type: 'points',
      },
      {
        title: 'Обеспеченность школами',
        key: 'sc',
        type: 'points',
      },
      {
        title: 'Обеспеченность ВУЗами',
        key: 'idx_106_amount',
        type: 'hexagons',
      },
      {
        title: 'Обеспеченность ЦОНами',
        key: 'con',
        type: 'points',
      },
      {
        title: 'Доступность общественного питания',
        key: 'idx_108_amount',
        type: 'hexagons',
      },
      {
        title: 'Доступность объектов повседневного спроса',
        key: 'idx_109_amount',
        type: 'hexagons',
      },
      {
        title: 'Доступность объектов периодического спроса',
        key: 'idx_110_amount',
        type: 'hexagons',
      },
      {
        title: 'Доступность объектов эпизодического спроса',
        key: 'idx_111_amount',
        type: 'hexagons',
      },
      {
        title: 'Обеспеченность аптеками',
        key: 'idx_112_amount',
        type: 'hexagons',
      },
      {
        title: 'Обеспеченность поликлиниками',
        key: 'pol',
        type: 'points',
      },
      {
        title: 'Обеспеченность больницами',
        key: 'hos',
        type: 'points',
      },
    ],
  },
  {
    title: 'Неравенство и человеческий капитал',
    key: 'dif_hum_capital',
    checkable: false,
    children: [
      {
        title: 'Уровень доходов работающего населения',
        key: 'abs_index_201',
        type: 'hexagons',
      },
      {
        title: 'Уровень доходов проживающего населения',
        key: 'abs_index_202',
        type: 'hexagons',
      },
      {
        title: 'Уровень бедности',
        key: 'abs_index_203',
        type: 'hexagons',
      },
      {
        title: 'Преступления против общественного порядка',
        key: 'abs_index_207',
        type: 'hexagons',
      },
      {
        title: 'Преступления против здоровья населения',
        key: 'abs_index_208',
        type: 'hexagons',
      },
      {
        title: 'Преступления против личности',
        key: 'abs_index_209',
        type: 'hexagons',
      },
      {
        title: 'Преступления против собственности',
        key: 'abs_index_210',
        type: 'hexagons',
      },
      {
        title: 'Коэффициент демографической нагрузки',
        key: 'abs_index_212',
        type: 'hexagons',
      },
      {
        title: 'Средняя стоимость продажи 1 кв. м жилья',
        key: 'avg_price_per_m2_sale',
        type: 'hexagons',
      },
      {
        title: 'Средняя стоимость аренды 1 кв. м жилья',
        key: 'avg_price_per_m2_rent',
        type: 'hexagons',
      },
      {
        title: 'Обеспеченность станциями скорой помощи',
        key: 'fa',
        type: 'points',
      },
      // {
      //   title: 'Обеспеченность противопожарными службами',
      //   key: 'firefighters',
      //   type: 'points',
      // },
    ],
  },
  {
    title: 'Жилье и построенная среда',
    key: 'living_building',
    checkable: false,
    children: [
      {
        title: 'Обеспеченность местами сбора мусора',
        key: 'gc',
        type: 'points',
      },
    ],
  },
  {
    title: 'Мобильность и связность',
    key: 'mobility_connectivity',
    checkable: false,
    children: [
      {
        title: 'Количество ДТП',
        key: 'abs_index_401_amount',
        type: 'hexagons',
      },
      {
        title: 'Количество жертв ДТП',
        key: 'abs_index_402_amount',
        type: 'hexagons',
      },
      {
        title: 'Эффективность общественного транспорта',
        key: 'st',
        type: 'points',
      },
      {
        title: 'Соотношение времени в пути в часы пик и в часы без пробок',
        key: 'no_tj_lines',
        type: 'lines',
      },
      {
        title: 'Количество жертв ДТП (пешеходы, велосипедисты)',
        key: 'abs_index_412_amount',
        type: 'hexagons',
      },
    ],
  },
  {
    title: 'Здоровье и окружающая среда',
    key: 'health_environment',
    checkable: false,
    children: [
      {
        title: 'Обеспеченность секциями и фитнес клубами',
        key: 'fc_ss',
        type: 'points',
      },
      {
        title: 'Годовая тепловая амплитуда',
        key: 'index_513_absolute_value',
        type: 'hexagons',
      },
      {
        title: 'Вегетационный индекс (NDVI)',
        key: 'index_514_absolute_value',
        type: 'hexagons',
      },
      {
        title: 'Городской остров тепла ',
        key: 'lst1_summer',
        type: 'hexagons',
      },
    ],
  },
];

function AbsoluteTree() {
  const darkMode = useUnit($isDarkTheme);
  const language = useUnit($language);
  const absoluteLayers = useUnit($absoluteLayers);
  const changeAbsoluteLayers = useUnit(changeAbsoluteLayersEv);

  const onCheck = (checkedKeys, e) => {
    const { node, checkedNodes } = e;
    let payload = checkedNodes.map((item) => {
      return {
        name: item.key,
        type: item.type,
        title: item.title,
      };
    });

    if (
      node.type === 'hexagons' &&
      payload.filter((item) => item.type === 'hexagons').length > 1
    ) {
      payload = [
        ...payload.filter((item) => item.type !== 'hexagons'),
        {
          name: node.key,
          type: node.type,
          title: node.title,
        },
      ];
    }
    changeAbsoluteLayers(payload);
  };

  return (
    <Tree
      style={{ color: darkMode ? 'white' : '#717171' }}
      switcherIcon={<DownOutlined />}
      treeData={mock_data}
      multiple
      checkable
      selectable={false}
      onCheck={onCheck}
      checkedKeys={absoluteLayers.map((item) => item.name)}
    />
  );
}

export default AbsoluteTree;
